import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery } from '@apollo/react-hooks'
import {
  VolumeChartByClientId_clientCharts,
  VolumeChartByClientId_clientChartsVariables
} from '../../../_generated/VolumeChartByClientId_clientCharts'
import { Precision } from '../../../_generated/globalTypes'

export const QUERY = gql`
query VolumeChartByClientId_clientCharts($id: ID!, $precision: Precision!) {
  charts {
    byClientId(id: $id) {
      id: clientId
      volume(precision: $precision) {
        begin
        valuesCount
        values
        labels
        currency
      }
    }
  }
}`

export type Q = VolumeChartByClientId_clientCharts
export type V = VolumeChartByClientId_clientChartsVariables
export type R = Q['charts']['byClientId']['volume']

export const parseData = (data: Q): R => {
  return get(data, p=> p.charts.byClientId.volume)
}

export function Use(clientId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: clientId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
